module.exports = __webpack_public_path__ + "static/media/save-energy.5b5f08e5.jpg";